<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat protokol' | translate" route-name="protocolNew"></add-button>
      <h1 v-translate>Protokoly</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="table_overflow">
        <table class="vypis vypis_detail">
        <thead>
        <tr>
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"/>
          <sorting-table-title
              v-for="title in protocolsTableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit"></th>
        </tr>
        </thead>

        <protocol-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            @deleteProtocol="deleteEntity"
            :selectedEntities="selectedEntities"
            @input="select"
            :ref="'protocol-row-ref-'+entity.id"
        ></protocol-row>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import ProtocolRow from "@/components/views/protocols/ProtocolRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "Protocols",
  components: {
    ProtocolRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'protocols',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      }
    }
  },
  created(ProtocolService) {
    this.entityService = ProtocolService
    this.createdInit()
  },
  computed: {
    protocolsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název protokolu'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Prefix'), column: 'sPrefix'},
        {key: 4, name: this.$gettext('Port'), column: 'sPort'},
        {key: 5, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 6, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.protocolsTableTitles)
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
        if (message.match("^Unable to delete protocol - there are (.+) device types with given protocol\.$")) {
          errorMessage = this.$gettext("Protokol nelze smazat - existují typy zařízení s tímto protokolem.");
        } else {
          errorMessage = message;
        }
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/protocols/ProtocolsList.vue